export enum DownPaymentType {
  Disabled,
  DownPaymentOnly,
  DownPaymentAndFullPrice
}
